import pharmacy from 'services/pharmacy';
import { useDispatch } from 'react-redux';
import { SET_ERROR_MESSAGE } from 'helpers/types';
import { browserHistory } from 'App';

export default () => {
  const dispatch = useDispatch();
  const postP5Order = async (paymentJourney, medicationState, basketMedication, gpNotes, totalValue) => {
    const order = {
      medications: basketMedication.map((medication) => ({
        name: medication.name,
        form: medication.form,
        full_medication: medication.full_medication,
        price_in_pence: medication.price_in_pence,
        item_id: medication.item_id,
      })),
      total_amount: totalValue * 100,
      gp_notes: gpNotes,
      fulfillment: {
        delivery_type: paymentJourney.delivery_type,
        address: {
          address_line1:
            paymentJourney.delivery_type === 'homeDelivery'
              ? paymentJourney.address.address_line1
              : paymentJourney.address.address.address_line2,
          address_line2:
            paymentJourney.delivery_type === 'homeDelivery'
              ? paymentJourney.address.address_line2
              : paymentJourney.address.address.address_line3,
          address_line3:
            paymentJourney.delivery_type === 'homeDelivery'
              ? paymentJourney.address.address_line3
              : paymentJourney.address.address.address_line4,
          address_line4: '',
          address_line5: '',
          postcode: paymentJourney.address.postcode,
        },
      },
      ...(Object.keys(paymentJourney.exemption).length !== 0 && {
        exemption: {
          code: paymentJourney.exemption.type.option,
          name: paymentJourney.exemption.type.text,
          ...(paymentJourney.exemption.cert_number && { number: paymentJourney.exemption.cert_number }),
          ...(paymentJourney.exemption.cert_expiry && { expiry_date: paymentJourney.exemption.cert_expiry }),
          ...(paymentJourney.exemption.ni && { ni_number: paymentJourney.exemption.ni }),
        },
      }),
      ...(Object.keys(paymentJourney.payment).length !== 0 && { card_token: paymentJourney.payment.token }),
    };

    try {
      return await pharmacy.post(`/patients/non-im1-orders`, order);
    } catch (e) {
      if (e.response && e.response.data.readable_error_message) {
        dispatch({
          type: SET_ERROR_MESSAGE,
          payload: {
            msg: e.response.data.readable_error_message,
            newMessage: true,
            link: '',
            ctaText: '',
          },
        });
        browserHistory.push('/pharmacy/error');
      }
      throw e;
    }
  };

  return [postP5Order];
};
